import BtSupervisionTableRow from './BtSupervisionTableRow';
import { FTableContainer } from '../../../base';
import { behaviorManagementHeaderConfig, behaviorManagementData } from './constants';

import type { IBtSupervision } from '../../../../utils/types';

interface BehaviorManagementProps {
  isEditable: boolean;
  btSupervision: IBtSupervision;
  onUpdateValue: (key: string, value: string) => void;
}

function BehaviorManagement({ isEditable, btSupervision, onUpdateValue }: BehaviorManagementProps) {
  return (
    <FTableContainer
      sx={{ mt: 3, borderRadius: '0px 0px 4px 4px' }}
      headerStyle={{ borderRadius: '4px 4px 0px 0px', pl: 3, px: 0 }}
      headerConfig={behaviorManagementHeaderConfig}
    >
      {behaviorManagementData.map((item) => {
        return (
          <BtSupervisionTableRow
            key={item.id}
            value={item.label}
            headerConfig={behaviorManagementHeaderConfig}
            isEditable={isEditable}
            selectedValue={{
              key: item.key,
              value: btSupervision[item.key],
            }}
            onChange={onUpdateValue}
          />
        );
      })}
    </FTableContainer>
  );
}

export default BehaviorManagement;
